import { Link } from 'react-router';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Button from '@mui/joy/Button';
import Cancel from '@mui/icons-material/Cancel';

export default function CreditsCancel() {
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '60vh',
      p: 2
    }}>
      <Card sx={{ maxWidth: 500, textAlign: 'center' }}>
        <CardContent sx={{ gap: 3, alignItems: 'center' }}>
          <Cancel sx={{ fontSize: 80, color: 'warning.500' }} />

          <Box>
            <Typography level="h2" sx={{ mb: 1 }}>
              Purchase Cancelled
            </Typography>
            <Typography level="body-lg" color="neutral">
              You haven{"'"}t been charged. Your credit purchase was cancelled.
            </Typography>
          </Box>

          <Typography level="body-md" color="neutral" sx={{ maxWidth: 400 }}>
            If you need additional credits, you can try again from the billing settings page.
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button
              size="lg"
              component={Link}
              to="/settings/billing"
            >
              View Billing
            </Button>
            <Button
              size="lg"
              variant="outlined"
              component={Link}
              to="/dashboard"
            >
              Go to Dashboard
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
